import { isAxiosError } from "axios";

export function extractUploadErrorMessage(error: unknown): string {
  if (!isAxiosError(error)) {
    return "unknownError";
  }
  const data = error.response?.data;
  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }
  if (data && typeof data === "object") {
    const err = (data as { error?: unknown }).error;
    if (typeof err === "string" && err.trim()) return err.trim();
    const msg = (data as { message?: unknown }).message;
    if (typeof msg === "string" && msg.trim()) return msg.trim();
  }
  if (error.code === "ERR_NETWORK") {
    return "uploadNetworkError";
  }
  if (error.message?.trim()) {
    return error.message.trim();
  }
  return "unknownError";
}

/** Prefer i18n key when defined; otherwise show the raw API message. */
export function formatUploadErrorForDisplay(
  message: string,
  t: (key: string) => string,
): string {
  const translated = t(message);
  return translated === message ? message : translated;
}
